export default class LetterSignature {
    constructor(id, type, coordinates, name, signed, declined, actor, signedAt, declinedAt, signable, mandatory) {
        this.id = id;
        this.type = type;
        this.name = name;
        this.signed = signed;
        this.declined = declined;
        this.coordinates = coordinates;
        this.color = null;
        this.font = null;
        this.sizePx = null;
        this.actor = actor;
        this.signedAt = signedAt ? new Date(signedAt) : null;
        this.declinedAt = declinedAt ? new Date(declinedAt) : null;
        this.signable = signable;
        this.mandatory = mandatory;
    }

    clone() {
        return new LetterSignature(
            this.id,
            this.type,
            { ...this.coordinates },
            this.name,
            this.signed,
            this.declined,
            this.actor,
            this.signedAt ? new Date(this.signedAt) : null,
            this.declinedAt ? new Date(this.declinedAt) : null,
            this.signable,
            this.mandatory,
        );
    }

    sign(name, font, color, sizePx) {
        this.name = name;
        this.signed = true;
        this.declined = false;
        this.font = font;
        this.color = color;
        this.sizePx = sizePx;
    }

    decline() {
        this.name = '';
        this.declined = true;
        this.signed = null;
        this.font = null;
        this.color = null;
        this.sizePx = null;
    }

    unsign() {
        this.name = null;
        this.signed = false;
    }

    serialize() {
        if (this.declined) {
            return { id: this.id };
        }
        return {
            id: this.id,
            name: this.signed ? this.name : null,
            fontColor: this.color,
            fontFamily: this.font,
            fontSizePx: Number.parseFloat(this.sizePx), // convert int to float
        };
    }

    getCoordinatesAsCss() {
        return `position: absolute; left: ${this.coordinates.x}px; top: ${this.coordinates.y}px;width: ${this.coordinates.width}px; height: ${this.coordinates.height}px;`;
    }

    isSignableByCustody() {
        return ['firstCustody', 'firstCustodyOptional', 'secondCustody', 'secondCustodyOptional'].includes(this.type);
    }

    isSignableByEmployee() {
        return this.type === 'employee';
    }
}
